import { render } from "./ADSMainList.vue?vue&type=template&id=b32eb2d4"
import script from "./ADSMainList.vue?vue&type=script&lang=js"
export * from "./ADSMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__